import React from 'react';

const theme = {
  colors: {
    purple: '#9747ff',
    white: 'rgba(255, 255, 255, 1)',
    g1: 'rgba(251, 251, 251, 1)',
    g2: 'rgba(238, 238, 238, 1)',
    g3: '#d9d9d9',
    g4: 'rgba(179, 179, 179, 1)',
    g5: 'rgba(132, 132, 132, 1)',
    black: 'rgba(0, 0, 0, 1)',
  },
  fonts: {
    heading: `font-family: Pretendard;
font-size: 1.5rem;
font-style: normal;
font-weight: 600;
line-height: 120%; /* 1.8rem */`,
    subText: `font-family: Pretendard;
font-size: 1.125rem;
font-style: normal;
font-weight: 600;
line-height: 120%; /* 1.35rem */`,
    body1: `font-family: Pretendard;
font-size: 1rem;
font-style: normal;
font-weight: 500;
line-height: 120%; /* 1.2rem */`,
    body2: `font-family: Pretendard;
font-size: 1rem;
font-style: normal;
font-weight: 400;
line-height: 120%; /* 1.2rem */`,
    caption1: `font-family: Pretendard;
font-size: 0.75rem;
font-style: normal;
font-weight: 400;
line-height: 120%; /* 0.9rem */`,
    caption2: `font-family: Pretendard;
font-size: 0.625rem;
font-style: normal;
font-weight: 400;
line-height: 120%; /* 0.75rem */`,
  },
};

export default theme;
